module.exports = __webpack_public_path__ + "public/images/about-logo.b76189461c0bed37ceff5086d04c48a6.svg";